// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"182":"bf35ec56","309":"3ac95732","383":"bf35ec56","484":"bf35ec56","956":"0c0fca49"}[chunkId] + ".chunk.css";
};